import React, { useEffect, useState } from 'react';
import './App.css';
import {
  ThemeProvider,
  createTheme

} from '@aviatrix/flights';
import fsTheme from './fsTheme';

import { Provider } from 'react-redux';
import store from './store';

import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import Template from './Template';


import InitializeGoogleAnalytics from "./GoogleAnalytics";
import InitializeDatadogRum from "./Datadog";
import { initializePendo } from "./Pendo";


function App() {

  const [mode, setMode] = useState('light')

  const { theme } = React.useMemo(() => {
    return {
      theme: createTheme({
        //spacing: 8,

        //nonce,
        palette: { ...fsTheme['light'], mode: 'light' },
        typography: fsTheme.typography,
        components: fsTheme.components
      })
    };
  }, []);

  useEffect(()=>{
    InitializeDatadogRum();
    InitializeGoogleAnalytics();
    const apiKey = process.env.REACT_APP_PENDO_KEY;
    if (apiKey){

      // Handle the async initializePendo function
      (async () => {
        try {
          await initializePendo({
            apiKey: apiKey,
            visitor: {
              id: process.env.REACT_APP_ENV
            },
            account: {
              id: process.env.REACT_APP_ENV
            }
          });
          
        } catch (error) {
          console.error('Failed to initialize Pendo:', error);
        }
      })();
    }
    
  }, []);


  return (

    <Provider store={store}>
      <ThemeProvider theme={theme}>

        <BrowserRouter>
          <Template>
            <AppRoutes />
          </Template>
        </BrowserRouter>

      </ThemeProvider>
    </Provider>

  );
}

export default App;
